import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export enum ProgressStage {
    None = 0,
    Briefing,
    Test,
    Complete
}

export interface IBriefingProgress {
    totalPageCount: number;
    quizStartsAtIndex: number;
    quizStartsAtPageID: string;
    currentPageIndex: number;
}

export class BriefingProgress {

    constructor(data?: IBriefingProgress) {
        if (data) this.update(data);
    }

    update(data: IBriefingProgress): BriefingProgress {
        mapData(data, { root: () => this });
        return this;
    }

    totalPageCount: number = 0;
    quizStartsAtIndex: number = 0;
    quizStartsAtPageID: string = Utils.emptyGuidValue;
    currentPageIndex: number = 0;

    // see resizeObserver below
    containerWidth: number = 0;

    get percent(): number {
        // add one to count for the 'done' page
        //return ((this.currentPageIndex + 1) / (this.totalPageCount + 1)) * 100;

        // use index rather than page-number to account for the extra 'done' page
        return !this.totalPageCount || !this.currentPageIndex
            ? 0
            : (this.currentPageIndex / this.totalPageCount) * 100;
    }

    get stage(): ProgressStage {
        if(this.currentPageIndex >= this.totalPageCount) return ProgressStage.Complete;
        if(this.currentPageIndex >= this.quizStartsAtIndex) return ProgressStage.Test;
        return ProgressStage.Briefing;
    }

    isQuizPage(pageIndex: number): boolean {
        console.log("this.quizStartsAtIndex = ", this.quizStartsAtIndex);
        return this.quizStartsAtIndex > -1 && pageIndex >= this.quizStartsAtIndex;
    }

    isFuturePage(pageIndex: number): boolean {
        return pageIndex > this.currentPageIndex;
    }

    setResizeObserver(cssClassName: string) {
        const div = document.getElementsByClassName(cssClassName)[0];
        const resizeObserver = new ResizeObserver(entries => {
            const rect = div.getBoundingClientRect();
            //const right = rect.x + rect.width;
            this.containerWidth = rect.width;
            //matrixAddButton.style.left = String(right - 75) + "px";
        });
        resizeObserver.observe(div);
    }
}